'use client'

import { useEECEvents } from 'analytics/hooks/useEECEvents/useEECEvents'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import {
	DEFAULT_LOOK_ID,
	SELECTED_SIZE_ID_KEY,
} from 'product/constants/constants'
import { env } from 'utils/envManager/envManager'
import { ClientLink, type ClientLinkProps } from 'utils/link/client/ClientLink'
import { removeFromSessionStorage } from 'utils/webStorage/sessionStorage'

import type { PdpClientLinkProps } from '../types/PdpLink.types'
import { getProductUrl } from '../utils/getProductUrl/getProductUrl'

export function PdpClientLink({
	product,
	colorId,
	lookId,
	sizeId,
	children,
	linkProps,
	location,
	skipTabKey,
	listId,
	listName,
	metaAs,
}: Readonly<PdpClientLinkProps>): React.ReactNode {
	const { sendSelectItem } = useEECEvents()
	const {
		country: { countryISO, languageISO },
	} = useMasterData()

	const productUrl = getProductUrl({
		product,
		colorId,
		lookId,
		countryISO,
		languageISO,
	})

	const href = productUrl.startsWith('/')
		? `${env.NEXT_PUBLIC_CURRENT_ORIGIN}${productUrl}`
		: productUrl

	const props: ClientLinkProps = {
		...linkProps,
		children,
		href,
		isLocalizedPath: true,
		prefetch: false,
		onClick: () => {
			void sendSelectItem({
				item: {
					colorId,
					sizeId,
					lookId: lookId || DEFAULT_LOOK_ID,
					productId: product.id,
					quantity: 1,
				},
				location,
				listId,
				listName,
			})
			removeFromSessionStorage(SELECTED_SIZE_ID_KEY)
			if (linkProps?.onClick) {
				linkProps.onClick()
			}
		},
		skipTabKey,
	}

	return (
		<>
			{metaAs && <meta itemProp={metaAs} content={href} />}
			<ClientLink {...props}>{children}</ClientLink>
		</>
	)
}
